// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"384a60f9","453":"dcac9de4","553":"e40a59e8","977":"ab3823cf"}[chunkId] + ".chunk.js";
};